const MESSAGE_SELECTOR = '[data-chat-message]';

function getLastMessage(messagesElement) {
  if (!messagesElement) {
    return null;
  }

  const messages = messagesElement.querySelectorAll(MESSAGE_SELECTOR);
  return messages.item(messages.length - 1);
}

export const elementScrollArrowStrategy = (messagesContainerRef, messagesRef) => ({
  getScrollContainer: () => messagesContainerRef.current,
  getResizeObserverTarget: () => getLastMessage(messagesRef.current),

  shouldShowArrow: () => {
    if (!messagesRef.current || !messagesContainerRef.current) {
      return false;
    }

    const lastMessage = getLastMessage(messagesRef.current);
    if (!lastMessage) {
      return false;
    }

    const scrollContainer = messagesContainerRef.current;
    const lastMessageBottom = lastMessage.getBoundingClientRect().bottom;
    const containerBottom = scrollContainer.getBoundingClientRect().bottom;

    // Add 1px tolerance to account for sub-pixel rounding.
    return lastMessageBottom > Math.ceil(containerBottom + 1);
  },

  scrollDown: () => {
    if (!messagesContainerRef?.current || !messagesRef?.current) {
      return;
    }

    const lastMessage = getLastMessage(messagesRef.current);
    if (!lastMessage) {
      return;
    }

    lastMessage.scrollIntoView({ behavior: 'smooth', block: 'end' });
  },

  attachScrollListener: listener => {
    messagesContainerRef.current?.addEventListener('scroll', listener);
  },

  detachScrollListener: listener => {
    messagesContainerRef.current?.removeEventListener('scroll', listener);
  },
});
